// extracted by mini-css-extract-plugin
module.exports = {"app":"app--app-styles__1aFqX"};